import { __awaiter } from "tslib";
/**
 * 经销商管理-买家管理
 * */
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import API from '@/services';
import { uniqueArr } from '@/shared/functions';
import luban from '@souche-f2e/luban-js';
import { paddingZero } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
// desc 添加买家相关数据
const addBuyer = {
    requesting: false,
    visible: false,
    clearCodeModal: false,
    currentShow: 0,
    isCheYiPai: false,
    tip: ['请先对买家进行实名认证'],
    addData: {},
    codeTip: '获取验证码',
    codeSecond: 60,
    isGetCode: false,
    isAuthentication: false,
    authenticationData: {},
};
// desc 表格及表单数据
const initFormTableData = {
    pageSize: 20,
    pageIndex: 0,
    total: 0,
    tableData: [],
    searchData: {},
};
// desc 号牌操作相关数据
const code = {
    codeShow: false,
    editData: {},
};
// desc 银行卡号
const bank = {
    showBank: false,
    bankMsg: {
        bankName: '',
        bankCode: '',
    },
};
export default createStore({
    state: Object.assign(Object.assign(Object.assign(Object.assign({}, addBuyer), initFormTableData), code), bank),
    effects: {
        // desc 更新表格
        updateTable(params, { state }) {
            const { pageIndex } = params;
            const { searchData } = state;
            if (searchData.time) {
                searchData.registerStartDate = searchData.time[0];
                searchData.registerEndDate = searchData.time[1];
                delete searchData.time;
            }
            const queryParams = Object.assign({ currentIndex: pageIndex || state.pageIndex, pageSize: state.pageSize }, searchData);
            API.user.buyerList(queryParams)
                .then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items) || [],
                    total: res.totalNumber || 0,
                    pageIndex: res.currentIndex,
                });
            });
        },
        // desc 实名认证（添加买家 & 实名认证）
        addReq({ formData, callback }, { state }) {
            state.isAuthentication ?
                this.verifiedUser({
                    paramsData: formData,
                    callback: () => {
                        const { authenticationData } = state;
                        const mobile = authenticationData.mobile;
                        // desc 认证提示
                        return {
                            isCheYiPai: true,
                            mobile,
                            tip: [`已向买家尾号${mobile.slice(-4)}的手机号发送验证码，请与买家验证`],
                        };
                    },
                })
                :
                    this.verifiedUser({
                        paramsData: formData,
                        callback: (res) => {
                            const isCheYiPai = res.cypUser || false;
                            const mobile = isCheYiPai ? (res.mobile || '') : '';
                            // desc 认证提示
                            const tipList = {
                                success: [
                                    '实名认证已通过，请添加买家手机号',
                                ],
                                success_che: [
                                    '此用户为车易拍商户，添加需进行买家验证;',
                                    `已向买家尾号${mobile.slice(-4)}的手机号发送验证码，请与买家验证`,
                                ],
                            };
                            const tip = isCheYiPai ? tipList.success_che : tipList.success;
                            return {
                                isCheYiPai,
                                mobile,
                                tip,
                            };
                        },
                    });
        },
        // desc 实名认证接口调用
        verifiedUser({ paramsData, callback }, { state }) {
            const { addData, isAuthentication } = state;
            const params = Object.assign({}, paramsData);
            isAuthentication && (params.createType = 'WX');
            API.user.RealNameAuthenticated(Object.assign({}, params))
                .then((res) => {
                const { isCheYiPai, mobile, tip } = callback(res || {});
                this.SET_STATE({
                    tip,
                    isCheYiPai,
                });
                const nextData = {
                    formData: Object.assign({}, addData, Object.assign(Object.assign({}, paramsData), { mobile })),
                };
                isCheYiPai && (nextData.callback = callback);
                this.addNext(nextData);
            })
                .catch((err) => {
                this.SET_STATE({
                    tip: [err.msg || '实名认证失败'],
                });
            });
        },
        // desc 校验手机
        addPhone({ formData }, { state }) {
            const callback = (res, userId) => {
                this.SET_STATE({
                    tip: ['用户已创建成功，可设置买家号码牌'],
                });
                this.addNext({
                    formData: Object.assign(Object.assign({}, formData), { userId }),
                });
                notification.success({
                    message: '用户已创建成功，可设置买家号码牌',
                });
                luban.send({
                    typeId: 'PSGJB-DEALER-MJJXS-TJMJ',
                    eventType: 'click',
                });
            };
            const params = {
                formData,
                callback,
            };
            state.isAuthentication ? this.verifyPhoneAuthentication(params) : this.verifyPhoneAdd(params);
        },
        // desc 校验手机（添加买家）
        verifyPhoneAdd({ formData, callback }, { state }) {
            const { addData } = state;
            API.user.checkVerificationCode(Object.assign(Object.assign(Object.assign({}, addData), formData), { mobile: formData.mobile || addData.mobile }))
                .then((res) => {
                callback(res, res.userId);
            });
        },
        // desc 校验手机（实名认证）
        verifyPhoneAuthentication({ formData, callback }, { state }) {
            const { authenticationData } = state;
            API.user.checkCodeAndRealNamefromWxUser(Object.assign(Object.assign(Object.assign({}, state.addData), formData), { mobile: authenticationData.mobile }))
                .then((res) => {
                callback(res, authenticationData.userId);
            });
        },
        // desc 获取验证码（添加买家 & 实名认证）
        getReqCode({ mobile, callback }, { state }) {
            API.user.getVerificationCode({
                mobile,
            })
                .then(() => {
                callback && callback();
            })
                .catch(() => {
                notification.warn({
                    message: '验证码获取失败',
                    description: '请重试',
                });
            });
        },
        // desc 添加号牌 （添加买家 & 实名认证)
        addCode({ formData, callback }, { state }) {
            const { addData, authenticationData } = state;
            let userId = addData.userId;
            state.isAuthentication && (userId = authenticationData.userId);
            if (formData !== {}) {
                if (formData.cardNum) {
                    formData.numberPlate = paddingZero(formData.cardNum, 3);
                    delete formData.cardNum;
                }
                this.editBuyerInterface(Object.assign(Object.assign({}, formData), { souCheUserId: userId }))
                    .then(() => {
                    this.HIDE_ADD_MODAL();
                    this.RESET_ADD_MODAL();
                });
            }
            else {
                this.HIDE_ADD_MODAL();
                this.RESET_ADD_MODAL();
                this.updateTable({});
            }
        },
        // desc 添加买家&实名认证-下一步
        addNext({ formData, callback }, { state }) {
            const { currentShow, addData } = state;
            const totalData = Object.assign({}, addData, formData);
            this.SET_STATE({
                currentShow: currentShow + 1,
                addData: totalData,
            });
            callback && callback();
        },
        // desc 修改or添加号牌
        editOrAddCode({ newCode, callback }, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const params = {
                    numberPlate: paddingZero(newCode, 3),
                    userId: state.editData.userId,
                };
                state.editData.numberPlate !== fontEndConfig.noValueReplace ?
                    this.editPlate({ params, callback })
                    :
                        this.addPlate({ params, callback });
            });
        },
        // desc 添加号牌
        addPlate({ params, callback }, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield API.user.insertNumberPlate(params)
                    .then(() => {
                    this.HIDE_CODE_EDIT();
                    callback ? callback() : this.updateTable({
                        pageIndex: state.pageIndex,
                    });
                    notification.success({
                        message: '号牌添加成功',
                    });
                    luban.send({
                        eventType: 'click',
                        typeId: 'PSGJB-DEALER-MJJXS-TJHP',
                    });
                });
            });
        },
        // desc 修改号牌
        editPlate({ params, callback }, { state }) {
            API.user.editNumberPlate(params)
                .then(() => {
                this.HIDE_CODE_EDIT();
                callback ? callback() : this.updateTable({
                    pageIndex: state.pageIndex,
                });
                notification.success({
                    message: '号牌修改成功',
                });
                luban.send({
                    eventType: 'click',
                    typeId: 'PSGJB-DEALER-MJJXS-XGHP',
                });
            });
        },
        // desc 删除号牌
        delPlate(params, { state }) {
            console.log('state', state);
            API.user.deleteNumberPlate({
                userId: params.userId,
                numberPlate: paddingZero(params.numberPlate, 3),
            }).then(() => {
                notification.success({
                    message: '号牌删除成功',
                });
                this.updateTable({ pageIndex: state.pageIndex });
                luban.send({
                    eventType: 'click',
                    typeId: 'PSGJB-DEALER-MJJXS-SCHP',
                });
            });
        },
        // desc 查看银行卡账号
        queryBankMsg(params, { state }) {
            API.user.queryBankList({
                userId: params.userId,
            })
                .then((res) => {
                if (res && res.length > 0) {
                    this.SET_STATE({
                        showBank: true,
                        bankMsg: {
                            bankName: res[0].bankName || '暂无',
                            bankCode: res[0].bankCard || '暂无',
                        },
                    });
                }
                else {
                    notification.warn({ message: '暂无银行卡信息' });
                }
                luban.send({
                    eventType: 'click',
                    typeId: 'PSGJB-DEALER-MJJXS-YHKCK',
                });
            });
        },
        RESET_DATA(state) {
            this.SET_STATE(Object.assign(Object.assign(Object.assign(Object.assign({}, addBuyer), initFormTableData), code), bank));
        },
        // desc 清空号牌
        submitClearCode(payload, state) {
            this.TOGGLE_CLEAR_CODE_MODAL();
            API.user.deleteNumberPlateByTenantCode({}).then(() => {
                notification.success({
                    message: '号牌清空成功',
                });
                this.updateTable({ pageIndex: 1 });
                luban.send({
                    eventType: 'click',
                    typeId: 'PSGJB-DEALER-MJJXS-SCHP',
                });
            });
        },
        // desc 展示添加买家Modal
        SHOW_ADD_MODAL(authenticationData, { state }) {
            this.SET_STATE({
                visible: true,
                isAuthentication: Boolean(authenticationData),
                authenticationData,
            });
        },
        // desc 编辑买家详情信息
        editMsg(editData, { state }) {
            this.editBuyerInterface(Object.assign(Object.assign({}, editData), { souCheUserId: state.editMsgData.userId }))
                .then(() => {
                notification.success({
                    message: '买家详情编辑成功',
                });
                this.SET_STATE({
                    editMsgData: {},
                });
                this.HIDE_EDIT();
            });
        },
        // desc 编辑买家详情信息接口
        editBuyerInterface(editData, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield API.user.editUserMsg(Object.assign({}, editData))
                    .then(() => {
                    this.updateTable({});
                });
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        // desc 关闭添加买家Modal并重置数据
        HIDE_ADD_MODAL(state) {
            state.visible = false;
            state.isAuthentication = false;
            state.authenticationData = null;
        },
        // desc 一键清空号牌Modal
        TOGGLE_CLEAR_CODE_MODAL(state) {
            state.clearCodeModal = !state.clearCodeModal;
        },
        // desc 重置添加买家相关数据
        RESET_ADD_MODAL(state) {
            const resetKey = Object.keys(addBuyer);
            resetKey.forEach((v) => {
                state[v] = addBuyer[v];
            });
        },
        // desc 打开号牌编辑
        SHOW_CODE_EDIT(state, rowData) {
            state.codeShow = true;
            state.editData = rowData;
        },
        // desc 关闭号牌编辑
        HIDE_CODE_EDIT(state) {
            state.codeShow = false;
            state.editData = {};
        },
        // desc 查看银行卡号
        SHOW_BANK_MSG(state, { isShow, data }) {
            state.showBank = isShow;
            console.log(data);
            if (data) {
                state.bankMsg = {
                    bankName: data.bankName,
                    bankCode: data.bankCode,
                };
            }
            console.log(state.backMsg);
        },
        SHOW_EDIT(state, editData) {
            state.editVisible = true;
            state.editMsgData = editData;
        },
        HIDE_EDIT(state) {
            state.editVisible = false;
            state.editMsgData = {};
        },
    },
});
